import React from "react";
import { Typography } from "@mui/material";
import Vistianos1 from "./img/visittanos1.jpg";
import Horarios from "../../components/horarios";

function Location() {


  return (
    <>
    <div className="img-container" style={{ position: "relative" }}>
      <img src={Vistianos1} alt="iglesia-la-fe" style={{objectPosition: "top"}}/>
     <Typography variant="h1"
         style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          color: "white",
          textShadow: "2px 2px 4px rgba(0,0,0,0.7)",
          zIndex: 1,
        }}
     >
      ¡Te esperamos!
     </Typography>
    </div>
    <section className="page-section">
      <div className="container">
        <Horarios />
      </div>
    </section>
  </>
  );
}

export default Location;
